import React, { Component } from "react";
import "./stylesheets/login.css";
import { Getlogin } from "../../modules/serverCall";
import "bootstrap/dist/css/bootstrap.min.css";
import constant from "../../configs/constant";
import { FloatingLabel, Form } from "react-bootstrap";
import CheckAuth from "../../modules/Auth/authCheck";
import { browserName, fullBrowserVersion, isMobile } from "react-device-detect";

export default class Login extends Component {
  constructor(props) {
    super(props);
    CheckAuth();
    this.state = {
      username: "",
      password: "",
      scope: "BG",
      submitbutton: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    // Getlogin(this.state);
    var submitbutton = true;
    this.setState({
      submitbutton: submitbutton,
    });
    const fetchLogin = async () => {
      const response = await Getlogin(this.state);
      const dataresp = await response;
      if (dataresp === 1) {
        submitbutton = false;
        this.setState({
          submitbutton: submitbutton,
        });
      }
    };
    fetchLogin();

    // MySwal.fire('<p>Incorrect username or password, please try again!<p>');
    // const validation = this.validator.validate(this.state);
    // this.setState({
    //   validation
    // });
  };

  handleUsernameChange = (event) => {
    event.preventDefault();
    var submitbutton = true;
    if (this.state.password !== "" && this.state.password !== undefined) {
      submitbutton = false;
    }
    var username = event.target.value;

    this.setState({
      username: username,
      submitbutton: submitbutton,
    });
  };

  handlePasswordChange = (event) => {
    event.preventDefault();
    var submitbutton = true;
    if (this.state.username !== "" && this.state.username !== undefined) {
      submitbutton = false;
    }

    this.setState({
      password: event.target.value,
      submitbutton: submitbutton,
    });
  };

  render() {
    const logocompany = require("../../assets/images/ThejoNewLogobg.png");
    const backgroundImg = require("../../assets/images/IMG-20221104-WA0005.jpg");
    const loginImg = require("../../assets/images/loginimage.png");
    return (
      <>
        {isMobile === false ? (
          <div className="tonconl login-background">
            <div className="row d-flex justify-content-center dataLogin align-items-center mb-5">
              <div className="col-xl-3">
                <div className="card rounded-3 text-black">
                  <div className="row classHe">
                    <div className="col-lg-12">
                      <div className="card-body mx-md-4">
                        <div className="text-center marDown">
                          <img
                            src={logocompany}
                            alt="logo"
                            className="logo-width"
                          />
                          <h4 className="logo_name">
                            <b>BG</b>
                          </h4>
                          <span className="verClassLog">
                            {constant.appVersions}
                          </span>
                        </div>

                        <form method="POST" onSubmit={this.handleFormSubmit}>
                          <FloatingLabel label="Employee ID" className="mb-3">
                            <Form.Control
                              type="text"
                              onChange={this.handleUsernameChange}
                              required
                              name="username"
                              placeholder="Employee ID"
                            />
                          </FloatingLabel>

                          <FloatingLabel label="Password" className="mb-4">
                            <Form.Control
                              type="password"
                              name="password"
                              onChange={this.handlePasswordChange}
                              required
                              placeholder="Password"
                            />
                          </FloatingLabel>
                          <div className="text-center mb-5">
                            <button
                              className="btn btn-primry btn-block fa-lg gradient-custom-2 mb-5"
                              disabled={this.state.submitbutton}
                              type="submit"
                            >
                              Sign In
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer_name">
              <span className="footer-span">
                v.{browserName + " " + fullBrowserVersion}
              </span>
            </div>
          </div>
        ) : (
          <div className="tonconl login-background">
            <div className="row d-flex justify-content-center dataLogin align-items-center mb-5">
              <div className="col-xl-3">
                <div className="card rounded-3 text-black">
                  <div className="row classHe">
                    <div className="col-lg-12">
                      <div className="card-body mx-md-4">
                        <div className="text-center marDown">
                          <img
                            src={logocompany}
                            alt="logo"
                            className="logo-width"
                          />
                          <h4 className="logo_name">
                            <b>BG</b>
                          </h4>
                          <span className="verClassLog">
                            {constant.appVersions}
                          </span>
                        </div>

                        <form method="POST" onSubmit={this.handleFormSubmit}>
                          <FloatingLabel label="Employee ID" className="mb-3">
                            <Form.Control
                              type="text"
                              onChange={this.handleUsernameChange}
                              required
                              name="username"
                              placeholder="Employee ID"
                            />
                          </FloatingLabel>

                          <FloatingLabel label="Password" className="mb-4">
                            <Form.Control
                              type="password"
                              name="password"
                              onChange={this.handlePasswordChange}
                              required
                              placeholder="Password"
                            />
                          </FloatingLabel>
                          <div className="text-center mb-5">
                            <button
                              className="btn btn-primry btn-block fa-lg gradient-custom-2 mb-5"
                              disabled={this.state.submitbutton}
                              type="submit"
                            >
                              Sign In
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer_name">
              <span className="footer-span">
                v.{browserName + " " + fullBrowserVersion}
              </span>
            </div>
          </div>
        )}
      </>
    );
  }
}
